import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/index'
import VueCookies from 'vue-cookies'

require('@/utils/consoleBadges').logAppInfo();
Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.use(VueCookies);

import {library} from '@fortawesome/fontawesome-svg-core'

import {
    faCheck,
    faChevronDown,
    faChevronUp,
    faEdit,
    faPlus,
    faSave,
    faStepBackward,
    faStepForward,
    faTimes
} from '@fortawesome/free-solid-svg-icons'

import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'

import '../node_modules/bootstrap-vue/dist/bootstrap-vue.css'
import '../node_modules/bootstrap/dist/css/bootstrap.css'
import '../node_modules/animate.css/animate.min.css'

import 'promise-polyfill/src/polyfill';

const fontAwesomeIcons = [faEdit, faTimes, faSave, faCheck, faStepBackward, faStepForward, faChevronUp, faChevronDown, faPlus];

for (let icon of fontAwesomeIcons) {
    library.add(icon);
}


Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
